import { useState } from "react";

import classNames from "classnames";
import { Delete } from "neetoicons";
import { Button, Typography } from "neetoui";
import { useHistoryStore } from "stores/useHistoryStore";

import AlertMessage from "./Alert";

const Item = ({ title, isSelected, onClick }) => {
  const removeFromHistory = useHistoryStore.pickFrom();
  const [shouldShowDeleteAlert, setShouldShowDeleteAlert] = useState(false);

  const handleDeleteFromHistory = () => {
    removeFromHistory(title);
  };

  return (
    <div
      className={classNames(
        "flex w-full cursor-default items-center justify-between rounded-3xl px-6 py-2 text-center",
        {
          "bg-blue-500 text-white": isSelected,
          "bg-blue-100 text-black": !isSelected,
        }
      )}
      onClick={onClick}
    >
      <Typography>{title}</Typography>
      <Button
        className="text-red-600"
        icon={Delete}
        iconPosition="left"
        iconSize={32}
        style="link"
        onClick={() => setShouldShowDeleteAlert(true)}
      />
      <AlertMessage
        historyTitle={title}
        isOpen={shouldShowDeleteAlert}
        message="message.removeItem"
        title="title.delete"
        onClose={() => setShouldShowDeleteAlert(false)}
        onSubmit={handleDeleteFromHistory}
      />
    </div>
  );
};

export default Item;
